import { z } from "zod";
import { defineEvent } from "./registry.js";
/**
 * Müşteri kimliği olayları (Prompt 17, ADR 0017 §2–6). Yük KİŞİSEL VERİ TAŞIMAZ (yalnızca kimlikler ve kodlar): ad,
 * telefon, e-posta, plaka ayrıntı API'sinden izinle okunur.
 */
export const customerProfileCreatedV1 = defineEvent({
    type: "customers.profile.created",
    version: 1,
    description: "Müşteri profili açıldı",
    realtime: ["tenant"],
    payload: z.object({
        customerProfileId: z.uuid(),
        code: z.string(),
        createdVia: z.string(),
        homeStationId: z.uuid().nullable(),
        hasLoyaltyCard: z.boolean(),
    }),
});
export const customerProfileAnonymizedV1 = defineEvent({
    type: "customers.profile.anonymized",
    version: 1,
    description: "Müşteri profili KVKK silme başvurusuyla anonimleştirildi (kayıt silinmez; kişisel alanlar boşaldı)",
    realtime: ["tenant"],
    payload: z.object({
        customerProfileId: z.uuid(),
        dataSubjectRequestId: z.uuid().nullable(),
        vehicleCount: z.number().int(),
    }),
});
export const customerDriverLinkedV1 = defineEvent({
    type: "customers.driver.linked",
    version: 1,
    description: "Müşteri profili, açık rızayla müşteri uygulaması hesabına bağlandı",
    realtime: ["tenant"],
    payload: z.object({
        customerProfileId: z.uuid(),
        driverId: z.uuid(),
        linkId: z.uuid(),
        invitationId: z.uuid(),
    }),
});
export const customerDriverUnlinkedV1 = defineEvent({
    type: "customers.driver.unlinked",
    version: 1,
    description: "Müşteri uygulaması bağı koptu (sürücü kopardı, hesap silindi ya da profil anonimleştirildi)",
    realtime: ["tenant"],
    payload: z.object({
        customerProfileId: z.uuid(),
        driverId: z.uuid(),
        linkId: z.uuid().nullable(),
        reason: z.enum(["DRIVER", "TENANT", "ERASURE", "ACCOUNT_DELETED"]),
    }),
});
//# sourceMappingURL=customers.v1.js.map